import { EyeOff } from 'lucide-react';

export default function HideButton({ onClick }) {
  return (
    <button
      type="button"
      onClick={onClick}
      title="Bereich ausblenden"
      className="bg-surface border border-line text-ink-3 hover:text-ink-2"
      style={{
        display: 'inline-flex', alignItems: 'center', gap: 5,
        height: 28, padding: '0 10px', alignSelf: 'center',
        borderRadius: 'var(--radius-md)', cursor: 'pointer',
        fontSize: 11, fontWeight: 600,
      }}
    >
      <EyeOff size={12} aria-hidden="true" /> Ausblenden
    </button>
  );
}
